import axios from "axios";

const instance = axios.create({
    // baseURL: "http://localhost:9096/dddp/api/v1/",
    baseURL: "https://dddpcms.aoinnovations.org/dddp/api/v1/",
    auth: {
        username: 'admin',
        password: 'sow12345'
    }
});

export default instance;
